import {Module, VuexModule, getModule, Mutation, Action} from 'vuex-module-decorators'
import store from '@/store'
import {axios} from '@/plagins'
import {withoutAuthAxios} from '@/plagins'
import {User} from "@/modules/user/types";

var sha1 = require('sha1');

const token: string = localStorage['CRM_Token'];
const login: string = localStorage['CRM_Login'];
const new_token: string = localStorage['CRM_New_Token']
const defaultFingerPrint = '111finger111';
let fingerprint: string = localStorage.getItem('fingerPrint') || '';

if (!token && !fingerprint){

  fingerprint = defaultFingerPrint;
  localStorage.setItem('fingerPrint', defaultFingerPrint);

}

@Module({
  namespaced: true,
  name: 'user',
  store,
  dynamic: true
})
class UserData extends VuexModule {
  userInfo: User = {
    Active: '',
    ChPwdDate: '',
    Company: null,
    CompanyID: '',
    Email: '',
    ExpireDate: '',
    FName: '',
    Features: [],
    Groups: [],
    ID: '',
    LName: '',
    MName: '',
    Login: '',
    Phone: '',
    StartDate: '',
    ZIP: ''
  }
  salt = "2BxGf1tmIKs"

  token: string = token;
  login: string = login;
  new_token: string = new_token;
  APPSTORE: boolean = false;
  fingerprint: string = fingerprint;


  get Fingerprint(){
    return this.fingerprint;
  }
  
  get Login () {
    return this.login
  }

  get Token () {
    return this.token
  }

  
  @Mutation
  setAPPSTORE(boo: boolean){

    this.APPSTORE = boo;
    
  }


  session_token: string = '' // Такой же токен, только живет в сессии вью.
  // Нужен, что внутри сессии не спрашивать данные на каждый запрос

  @Mutation
  setUser(response: any) {
    console.log('userData', response)
    this.userInfo = response
    this.token = response.Token
    this.new_token = response.new_token
    this.login = response.Login
    this.session_token = response.Token || this.session_token

    localStorage['CRM_New_Token'] = response.new_token;
    localStorage['CRM_Token'] = response.Token;
    localStorage['Token'] = response.Token;
    localStorage['CRM_Login'] = response.Login;

    axios.defaults.headers.common['Token'] = localStorage.getItem('CRM_Token')
    axios.defaults.headers.common['Login'] = localStorage.getItem('CRM_Login')

    if (this.fingerprint){
      axios.defaults.headers.common['fingerprint'] = this.fingerprint;
    }
  }

  @Mutation
  setUserInfo(userInfo: any) {
    this.userInfo.FName = userInfo.fname
    this.userInfo.LName = userInfo.lname
    this.userInfo.Company = userInfo.company
    this.userInfo.CompanyID = userInfo.company_id
    if (localStorage['CRM_UserID']) this.userInfo.ID = localStorage['CRM_UserID']

    console.log('this.userInfo', this.userInfo)
  }

  @Action({commit: 'setUser', rawError: true})
  async getLogin(userData: any) {

    try {
      console.log(">>>>>>> action getLogin ---> userData: ", userData)
      userData.password = sha1(userData.password + this.salt).toUpperCase();

      const headers: any = {
        login: userData.login, 
        password: userData.password
      }

      headers.fingerprint = this.fingerprint || defaultFingerPrint;
      
      const response: any = await withoutAuthAxios.get('/user/SignIn', {
        headers
      })

      // if (response.data.result !== 'success') return Promise.reject()

      return Promise.resolve(response.data)

    } catch (err) {
      console.log('err', err)
      return Promise.reject(err)
    }
  }

  @Action({commit: 'setUser', rawError: true})
  async logout() {
    localStorage['CRM_Token'] = ""
    localStorage['CRM_Login'] = ""
    localStorage['CRM_New_Token'] = "";
    return {name: '', email: '', token: ''}
  }

  @Action({commit: 'setUser', rawError: true})
  async userInit() {
    try {
      // const response = await axios.post(`user/login`)
      const response = await axios.get(`/user/SignIn`)

      // if (response.data.result !== 'success') return Promise.reject()
      return Promise.resolve(response.data)
    } catch (err) {
      return Promise.reject()
    }
  }

  @Action({rawError: true})
  async updatePassword(oldPassword: string, newPassword: string) {
    try {
      const response: any = await axios.post('change', {oldPassword, newPassword})

      if (response.data.result !== 'success') return Promise.reject()
      return Promise.resolve(response.data.data.records as User)

    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Action({rawError: true})
  async forgotPassword(username: string) {
    try {
      const response: any = await axios.post('forgot', {username})

      if (response.data.result !== 'success') return Promise.reject()
      return Promise.resolve(response.data.data.records as User)

    } catch (err) {
      return Promise.reject(err)
    }
  }
}

export default getModule(UserData)
